import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';  // Import the Provider
import App from './App';                 // Your main App component
import { store } from './redux/store/store';
import "./index.css"; 

ReactDOM.render(
  <Provider store={store}>               {/* Wrap your App in Provider */}
    <App />
  </Provider>,
  document.getElementById('root')
);
